import { type DocumentData, serverTimestamp } from 'firebase/firestore';

import { getDocument, subscribeToDocument, updateDocument } from '../firestore';

const CONFIG_COLLECTION = 'config';
const LEGAL_DOC_ID = 'legal';
const USERS_COLLECTION = 'users';

export async function getLegalConfig(): Promise<(DocumentData & { id: string }) | null> {
  return getDocument(CONFIG_COLLECTION, LEGAL_DOC_ID);
}

export function subscribeToLegalConfig(
  callback: (data: (DocumentData & { id: string }) | null) => void,
): () => void {
  return subscribeToDocument(CONFIG_COLLECTION, LEGAL_DOC_ID, callback);
}

export async function updateUserConsent(
  uid: string,
  consentData: {
    termsAcceptedVersion: string;
    privacyAcceptedVersion: string;
    acceptedPlatform: 'web' | 'mobile';
  },
): Promise<void> {
  return updateDocument(USERS_COLLECTION, uid, {
    termsAccepted: true,
    termsAcceptedVersion: consentData.termsAcceptedVersion,
    termsAcceptedAt: serverTimestamp(),
    privacyAccepted: true,
    privacyAcceptedVersion: consentData.privacyAcceptedVersion,
    privacyAcceptedAt: serverTimestamp(),
    acceptedPlatform: consentData.acceptedPlatform,
  });
}
